
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateProductGroupDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    sortableRank: new FormControl<number | undefined>(undefined),
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    visibleItemFields: new FormControl<any | undefined>(undefined),
})
;
}
      